import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { BusStopsPicker } from './ui/bus_stops.js';

/**
 * Entrada de catálogo do `bus_stops` (slot chat). Read-only safe: o toque numa
 * candidata monta o quick-reply aqui (`reply`) com o NOME EXATO da opção — o
 * shell não conhece o texto; o agents resolve por nome (exact-match) contra as
 * candidatas pendentes server-side. Sem ação destrutiva (pick por reply).
 */
export const busStopsEntry: GenUiEntry<Extract<ChatUi, { kind: 'bus_stops' }>> = {
  kind: 'bus_stops',
  slot: 'chat',
  policy: { productOf: () => 'bus' },
  render: ({ ui, note, readOnly, dispatch }) => (
    <BusStopsPicker
      which={ui.which}
      options={ui.options}
      note={note}
      readOnly={readOnly}
      onPick={(name) => {
        dispatch({ type: 'reply', text: name });
      }}
    />
  ),
};
